// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qg-2";
export var chatLink = "_qg-0";
export var chatText = "_qg-1";